import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import { PageSource } from '@mc/track-event'
import { TrackingContainer } from '@mc/visibility'
import { GlobalCarousel } from 'components/GlobalCarousel'
import styles from './SubcatCourses.module.scss'
import { trackSubcatCarouselViewed, trackSubcatSeeAllClick } from './events'
import type { CarouselAbstractionProps, SubcatCoursesProps } from './props'
import { getNonRepeatingTileOrder } from './utils'

export const SubcatCourses = ({
  subcategories,
  classes,
  course,
  primaryCategory,
  pageSource = PageSource.CLASS_PAGE,
}: SubcatCoursesProps) => {
  if (classes.length <= 0) return <></>

  const currentCourseSlug = course?.slug || ''

  const coursesBySubcategory = getNonRepeatingTileOrder(
    subcategories,
    classes,
    currentCourseSlug,
  )

  return (
    <div className='container mc-mst-12 mc-py-10' id='category-classes'>
      {coursesBySubcategory.map((subcatCourses, idx) => (
        <div id={subcatCourses.name} key={subcatCourses.id} className='mc-mb-8'>
          <TrackingContainer
            onFirstVisible={() =>
              trackSubcatCarouselViewed(
                subcatCourses.name,
                primaryCategory?.name || '',
                idx,
                pageSource,
              )
            }
          >
            <GlobalCarousel
              carouselSlug={subcatCourses.slug}
              location='subcat-courses'
              tiles={subcatCourses.courses}
              title={
                <CarouselTitle
                  subcatCourses={subcatCourses}
                  primaryCategory={primaryCategory}
                  idx={idx}
                  pageSource={pageSource}
                />
              }
            />
          </TrackingContainer>
        </div>
      ))}
    </div>
  )
}

const CarouselTitle = ({
  subcatCourses,
  primaryCategory,
  idx,
  pageSource,
}: CarouselAbstractionProps) => {
  const { t } = useTranslation('@mc/next')

  const getSeeAllUrl = (subcatSlug: string) => {
    if (!primaryCategory || !primaryCategory.slug) {
      return paths.categories
    }

    return paths.subcategory(primaryCategory.slug, subcatSlug)
  }

  return (
    <div className='mc-pl-1 mc-mb-4'>
      <div className='d-flex flex-wrap align-items-baseline justify-content-between justify-content-sm-start'>
        <span
          className={`col-12 col-sm-auto mc-p-0 mc-mr-2 ${styles.sectionTitle}`}
        >
          {t('course.relatedCourses.moreIn')}
        </span>
        <span className='mc-text-h3'>{subcatCourses.name}</span>
        <a
          className='mc-text--normal mc-opacity--muted mc-ml-4'
          href={getSeeAllUrl(subcatCourses.slug)}
          onClick={() =>
            trackSubcatSeeAllClick(
              subcatCourses.name,
              primaryCategory?.name || '',
              idx,
              pageSource,
            )
          }
          target='_blank'
          rel='noreferrer'
        >
          {t('course.relatedCourses.seeAllCta')}
        </a>
      </div>
    </div>
  )
}
